import React from 'react';
import type { NodeProps } from '@xyflow/react';
import { Handle, Position } from '@xyflow/react';

import cn from '~/Utils/cn';

import type { TableNodeType } from './erdGraph';

export const TableNode: React.FC<NodeProps<TableNodeType>> = ({ data, selected }) => (
  <div
    className={cn('overflow-hidden rounded-md border bg-white text-xs shadow-sm', {
      'border-teal-600 shadow-md': selected,
      'border-teal-400 shadow-md': !selected && data.isConnected,
      'border-slate-300': !selected && !data.isConnected,
      'opacity-30': data.isDimmed,
    })}
  >
    <div className="flex h-32 items-center bg-slate-700 px-8 font-semibold text-white">{data.label}</div>
    {data.columns.map((column) => (
      <div
        key={column.name}
        className="relative flex h-24 items-center justify-between gap-8 border-t border-slate-100 px-8"
      >
        <Handle
          type="target"
          position={Position.Left}
          id={column.name}
          isConnectable={false}
          className="!h-2 !w-2 !opacity-0"
        />
        <span className="truncate">
          {column.name}
          {column.is_primary_key && (
            <span className="ml-4 rounded bg-yellow-100 px-4 font-semibold text-yellow-800">PK</span>
          )}
          {column.is_foreign_key && (
            <span className="ml-4 rounded bg-blueSky-100 px-4 font-semibold text-blueSky-700">FK</span>
          )}
        </span>
        <span className="truncate text-slate-400">{column.type}</span>
        <Handle
          type="source"
          position={Position.Right}
          id={column.name}
          isConnectable={false}
          className="!h-2 !w-2 !opacity-0"
        />
      </div>
    ))}
  </div>
);
